import { render, staticRenderFns } from "./tavalod.vue?vue&type=template&id=75be7c5f&scoped=true"
import script from "./tavalod.vue?vue&type=script&setup=true&lang=js"
export * from "./tavalod.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tavalod.vue?vue&type=style&index=0&id=75be7c5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be7c5f",
  null
  
)

export default component.exports